import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import Card from "/react4xp/components/shared/Card/Card";
import Person from "/react4xp/components/shared/frontend/assets/person.svg";
// import ArrowRight from "/react4xp/components/shared/frontend/assets/arrow-right.svg";
import Pagination from "/react4xp/components/shared/Pagination/Pagination";
// import SearchEmployee from "/react4xp/components/shared/SearchEmployee/SearchEmployee";

import type { EmployeeCardListProps } from "./EmployeeCardList.d";

export const EmployeeCardListPart = (props: ComponentProps<PartData>) => {
  const { data, pagination, urlPage, currentPage, limitPage, totalPage } =
    (props.data as EmployeeCardListProps) ?? {};

  const hasData = data.length > 0;

  return (
    <div className="employee-card-list">
      <section>
        {hasData &&
          data.map((employee) => (
            <Card compactView key={employee.id} className="employee-card">
              <Card.Image>
                {employee?.imageSrc ? (
                  <img src={employee.imageSrc} alt={"ansattes bilde"} />
                ) : (
                  <Person />
                )}
              </Card.Image>
              <Card.Body>
                <h3 className="employee-name">{employee.name}</h3>
                <ul>
                  {employee?.jobTitle && (
                    <li>
                      <p>{employee.jobTitle}</p>
                    </li>
                  )}
                  {employee?.phone && (
                    <li>
                      <a href={`tel:+${employee.phone}`}>{employee.phone}</a>
                    </li>
                  )}
                  {employee?.businessPhone && (
                    <li>
                      <a href={`tel:+${employee.businessPhone}`}>
                        {employee.businessPhone}
                      </a>
                    </li>
                  )}
                  {employee?.email && (
                    <li>
                      <a href={`mailto:${employee.email}`}>{employee.email}</a>
                    </li>
                  )}
                </ul>
              </Card.Body>
              <Card.Link>
                <a
                  href={employee.link}
                  title={`Se detaljer for ${employee.name}`}
                  aria-label={`Se detaljer for ${employee.name}`}
                ></a>
              </Card.Link>
            </Card>
          ))}
      </section>
      {pagination && hasData && (
        <Pagination
          current={currentPage}
          pages={totalPage}
          limit={limitPage}
          pageurl={urlPage}
        />
      )}
    </div>
  );
};

export default EmployeeCardListPart;
